export default "__VITE_ASSET__1wFaFI_f__"